<div class="rsp-spinner-overlay"></div>
<div class="rsp-spinner-wrapper">
  <div class="rsp-spinner spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
